import { IdTitle } from "utils/query";

export const gcpSupportedRegions: IdTitle[] = [
  { id: "us-central1", title: "US Central (Iowa)" },
  { id: "us-east1", title: "US East (South Carolina)" },
  { id: "us-east4", title: "US East (Virginia)" },
  { id: "us-west1", title: "US West (Oregon)" },
  { id: "us-west2", title: "US West (Los Angeles)" },
  { id: "us-west3", title: "US West (Salt Lake City)" },
  { id: "us-west4", title: "US West (Las Vegas)" },
  { id: "northamerica-northeast1", title: "Canada (Montreal)" },
  { id: "northamerica-northeast2", title: "Canada (Toronto)" },
  { id: "southamerica-east1", title: "South America (São Paulo)" },
  { id: "europe-west1", title: "Europe West (Belgium)" },
  { id: "europe-west2", title: "Europe West (London)" },
  { id: "europe-west3", title: "Europe West (Frankfurt)" },
  { id: "europe-west4", title: "Europe West (Netherlands)" },
  { id: "europe-west6", title: "Europe West (Zurich)" },
  { id: "europe-north1", title: "Europe North (Finland)" },
  { id: "asia-south1", title: "Asia South (Mumbai)" },
  { id: "asia-southeast1", title: "Asia Southeast (Singapore)" },
  { id: "asia-southeast2", title: "Asia Southeast (Jakarta)" },
  { id: "asia-east1", title: "Asia East (Taiwan)" },
  { id: "asia-east2", title: "Asia East (Hong Kong)" },
  { id: "asia-northeast1", title: "Asia Northeast (Tokyo)" },
  { id: "asia-northeast2", title: "Asia Northeast (Osaka)" },
  { id: "asia-northeast3", title: "Asia Northeast (Seoul)" },
  { id: "australia-southeast1", title: "Australia (Sydney)" },
  { id: "australia-southeast2", title: "Australia (Melbourne)" },
];

export const gcpMachineTypes: IdTitle[] = [
  {
    id: "e2-standard-2",
    title: "e2-standard-2 (2 vCPU, 8 GB) - Cost-optimized",
  },
  {
    id: "e2-standard-4",
    title: "e2-standard-4 (4 vCPU, 16 GB) - Cost-optimized",
  },
  {
    id: "e2-standard-8",
    title: "e2-standard-8 (8 vCPU, 32 GB) - Cost-optimized",
  },
  { id: "n1-standard-2", title: "n1-standard-2 (2 vCPU, 7.5 GB)" },
  { id: "n1-standard-4", title: "n1-standard-4 (4 vCPU, 15 GB)" },
  { id: "n1-standard-8", title: "n1-standard-8 (8 vCPU, 30 GB)" },
  { id: "n1-standard-16", title: "n1-standard-16 (16 vCPU, 60 GB)" },
  { id: "n2-standard-2", title: "n2-standard-2 (2 vCPU, 8 GB)" },
  { id: "n2-standard-4", title: "n2-standard-4 (4 vCPU, 16 GB)" },
  { id: "n2-standard-8", title: "n2-standard-8 (8 vCPU, 32 GB)" },
  { id: "n2-standard-16", title: "n2-standard-16 (16 vCPU, 64 GB)" },
  {
    id: "c2-standard-4",
    title: "c2-standard-4 (4 vCPU, 16 GB) - Compute-optimized",
  },
  {
    id: "c2-standard-8",
    title: "c2-standard-8 (8 vCPU, 32 GB) - Compute-optimized",
  },
  {
    id: "c2-standard-16",
    title: "c2-standard-16 (16 vCPU, 64 GB) - Compute-optimized",
  },
];
